import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextInventory } from '../Inventory';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Product } from '../../../../models/product.model';
import { Service } from '../../../../models/service.model';
import { Category } from '../../../../models/category.model';
import { AccountingAccount } from '../../../../models/accounting.account.model';

export interface CategoryPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  categoriesForCompany: Category[] | null,
  accountingExpenseAccountsForCompany: AccountingAccount[] | null,
  accountingVatAccountsForCompany: AccountingAccount[] | null,
  accountingIncomeAccountsForCompany: AccountingAccount[] | null,
  setCategoriesForCompany: Dispatch<SetStateAction<Category[] | null>>,
  loadServicesForCompany: Function,
  loadProductsForCompany: Function
};

const CategoryPage: React.FunctionComponent<CategoryPageProps> = props => {
  const {setRoute, appServiceForUser, companyForUser, servicesForCompany, productsForCompany, categoriesForCompany, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany, setCategoriesForCompany, loadServicesForCompany, loadProductsForCompany} = UseOutletContextInventory()

  return (
    <Outlet context={{setRoute, appServiceForUser, companyForUser, servicesForCompany, productsForCompany, categoriesForCompany, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany, setCategoriesForCompany, loadServicesForCompany, loadProductsForCompany}}></Outlet>
  );
}

export function UseOutletContextCategory() {
  return useOutletContext<ContexType>()
};

export default CategoryPage;
